import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  HouseIcon,
  DashboardIcon,
  QuestionMarkIcon,
  BusinessIcon,
  TeamIcon,
  SettingsIcon,
  ContactsIcon,
  ProjectsIcon,
  ServiceIcon,
  BoardCheckIcon,
  WalletIcon,
  DocumentIcon,
  KIIcon,
  PanelLeftIcon,
  PanelRightIcon,
} from "../../../shared/crm/components/icons/Icon";
import "./CRMSideTabs.scss";

function SideTabs() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => setIsCollapsed((prev) => !prev);

  const menuGroups = [
    {
      id: "group1",
      items: [
        {
          name: "Start",
          path: "/app/crm/übersicht",
          icon: <HouseIcon />,
        },
      ],
    },
    {
      id: "group2",
      title: "Core",
      items: [
        {
          name: "Übersicht",
          path: "/app/crm/übersicht",
          icon: <DashboardIcon />,
        },
        {
          name: "Firmen & Kontakte",
          path: "/app/crm/firmen-und-kontakte",
          icon: <BusinessIcon />,
        },
        {
          name: "Objekte",
          path: "/app/crm/objekte",
          icon: <HouseIcon />,
        },
        {
          name: "Benutzer & Rollen",
          path: "/app/crm/benutzer-und-rollen",
          icon: <TeamIcon />,
        },
        {
          name: "Einstellungen",
          path: "/app/crm/einstellungen",
          icon: <SettingsIcon />,
        },
      ],
    },
    {
      id: "group3",
      title: "Module",
      items: [
        {
          name: "CRM",
          path: "/app/crm/calendar",
          icon: <ContactsIcon />,
        },
        {
          name: "CRM - Pipeline",
          path: "/app/crm/news",
          icon: <DashboardIcon />,
        },
        {
          name: "Projekte",
          path: "/app/crm/bundles",
          icon: <ProjectsIcon />,
        },
        {
          name: "Service",
          path: "/app/crm/inbox",
          icon: <ServiceIcon />,
        },
        {
          name: "Abnahme",
          path: "/app/crm/calendar",
          icon: <BoardCheckIcon />,
        },
        {
          name: "Finanzen",
          path: "/app/crm/news",
          icon: <WalletIcon />,
        },
        {
          name: "Dokumente",
          path: "/app/crm/bundles",
          icon: <DocumentIcon />,
        },
        {
          name: "KI-Assistent",
          path: "/app/crm/inbox",
          icon: <KIIcon />,
        },
      ],
    },
  ];

  return (
    <nav className={`crm-side-tabs ${isCollapsed ? "crm-side-tabs--collapsed" : ""}`}>
      <div className="crm-side-tabs__menu">
        {isCollapsed ? (
          <button
            type="button"
            className="crm-side-tabs__toggle"
            onClick={toggleCollapse}
            title="Ausklappen"
            aria-label="Sidebar ausklappen"
            aria-expanded={false}
          >
            <PanelRightIcon className="crm-side-tabs__icon" />
          </button>
        ) : (
          <button
            type="button"
            className="crm-side-tabs__toggle"
            onClick={toggleCollapse}
            title="Einklappen"
            aria-label="Sidebar einklappen"
            aria-expanded={true}
          >
            <PanelLeftIcon className="crm-side-tabs__icon" /> Einklappen
          </button>
        )}
        <div className="crm-side-tabs__group-container">
          {menuGroups.map((group) => (
            <div
              key={group.id}
              className={`side-tabs__group ${
                group.id === "group4" || group.id === "group5"
                  ? "side-tabs__group--border"
                  : ""
              }`}
            >
              {group.title && (
                <span className="side-tabs__group-title">{group.title}</span>
              )}
              <div className="side-tabs__items">
                {group.items.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.path}
                    className={({ isActive }) =>
                      `crm-side-tabs__item ${isActive ? "crm-side-tabs__item--active" : ""}`
                    }
                    title={isCollapsed ? item.name : undefined}
                    aria-label={item.name}
                  >
                    <span className="crm-side-tabs__icon">{item.icon}</span>
                    {!isCollapsed && (
                      <span className="crm-side-tabs__tooltip">{item.name}</span>
                    )}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="crm-side-tabs__footer">
          {!isCollapsed && (
            <span className="crm-side-tabs__tooltip">
              <QuestionMarkIcon className="crm-side-tabs__icon" /> Hilfe
            </span>
          )}
        </div>
      </div>
    </nav>
  );
}

export default SideTabs;
